const hkform = document.querySelector('#hkCargoForm');
const addTotalCBM = document.querySelector('.cbm__total__numb');
const addTotalWeight = document.querySelector('.total__weight__numb');
const ratePesoTotal = document.querySelector('.ratePesoTotal');

hkform.addEventListener('submit', event => {
	event.preventDefault();

	// Multiply Total Rate * Total Package
	const totalPackage = parseFloat(hkform.totalPackage.value);

	// Total CBM
	const inputValues = parseFloat(hkform.length.value) * parseFloat(hkform.width.value) * parseFloat(hkform.height.value);

	const dividedTotalValues = inputValues / 1000000;

	const res = `${dividedTotalValues * totalPackage}`;

	addTotalCBM.textContent = `${res}`;

	// Total Weight
	const totalWeight = hkform.weight.value;

    // Total Weight by cm
	const pricePerWeight = 16500;

	addTotalWeight.textContent = `${totalWeight * totalPackage}`;


    const priceAboveCbm = res * pricePerWeight;
    console.log(priceAboveCbm);

    const priceBelowCbm = 3300;
  
    if(res > 0.2) {
      ratePesoTotal.textContent = `${(priceAboveCbm).toLocaleString()}`;
    } else {
      ratePesoTotal.textContent = `${(priceBelowCbm).toLocaleString()}`;
    }

	
});